export default __webpack_public_path__ + "static/media/rating_active_5.00978498.png";